
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { Color, Item, ItemInfo } from '@/store/models/ItemModel';
import J1lImg from '@/components/J1lImg.vue';
import DefaultLayout from '@/components/DefaultLayout.vue';
import ItemService from '@/services/item-service';
import HiRezImg from '@/components/HiRezImg.vue';
import AlertComponent from '@/components/AlertLayout.vue';
import { CookieHelpers } from '@/helpers/CookieHelper';
import { BuildItemAlertMessage } from '@/helpers/ObjectHelper';
import BarcodePlacement from '@/components/BarcodePlacement.vue';
import { AlertModel } from '@/store/models/DialogModel';
import { SetSnackBar } from '@/helpers/SnackbarHelper';
import { Confirm } from '@/helpers/AuthHelper';
@Component({
  components: {
    J1lImg,
    DefaultLayout,
    HiRezImg,
    AlertComponent,
    BarcodePlacement
  }
})
export default class extends Vue {
  $refs!: {
    alertForMaterial: HTMLFormElement;
    BarcodePlacement: HTMLFormElement;
  };
  /* Properties */
  /* Store Actions */
  @Action('ApproveItem', { namespace: 'items' })
  approveItem!: (payload: string) => void;
  @Getter('areDiesLoading', { namespace: 'dies' })
  isDiesLoading!: any;
  @Getter('dieTemplates', { namespace: 'dies' })
  dieTemplates!: any;
  /* Watchers */
  @Watch('currentStep')
  onCurrentStepChange(val: number) {
    if (val === 4) this.$refs.BarcodePlacement.SetItem(this.item);
  }
  /* Data */
  currentStep: number = 1;
  isApproving: boolean = false;
  itemSpecificationApproval: boolean = false;
  trimLineApproval: boolean = false;
  onlinePressApproval: boolean = false;
  accurateInfoApproval: boolean = false;
  imageClarityApproval: boolean = false;
  textApproval: boolean = false;
  item: Item = new Item();
  alertOption!: AlertModel;
  isMaterialAlertActive: boolean = false;
  isOptoutOptionChecked: boolean = false;
  availableColors: any = [];
  maskBuildType: string = 'trimmedlabel';
  /* Methods */
  close() {
    if (this.$route.params.shouldClose) {
      window.close();
    } else {
      this.$router.back();
    }
  }
  canApprove() {
    return (
      this.onlinePressApproval &&
      this.accurateInfoApproval &&
      this.imageClarityApproval &&
      this.textApproval
    );
  }
  onApproveCutAndMotion() {
    this.currentStep = 3;
    window.scrollTo(0, 0);
  }
  async goToBarcodePlacement() {
    await this.approve(true);
  }
  async onApproveClick() {
    if (this.item.NeedsBarcodePlacement) {
      Confirm(
        () => {
          this.goToBarcodePlacement();
        },
        'Place barcode?',
        'The item you are approving will need a position to place the data matrix code. Would you like to do this now?'
      );
    } else {
      this.approve();
    }
  }
  async approve(shouldGoToBarcodePlacement: boolean = false) {
    this.isApproving = true;
    try {
      this.approveItem(this.item.Id);
      this.$store.dispatch('items/refreshItem', this.item.Id);

      SetSnackBar('Item approved Successfully');
      if (shouldGoToBarcodePlacement) {
        this.$router.push({
          name: 'BarcodePlacement',
          params: { itemId: this.item.Id }
        });
      } else if (this.$route.params.shouldClose) {
        window.close();
      } else {
        this.$router.back();
      }
    } catch (error) {
      SetSnackBar(
        'There was an error approving your item. Please contact techsupport@just1label.com'
      );
    }

    this.isApproving = false;
  }
  /* Loaders */
  async loadItem(itemId: string) {
    const response = await ItemService.GetItemDetails(itemId);
    if (response.data) {
      const item = new Item(response.data);
      this.item = item;
    }
  }
  /* Mounted */
  async mounted() {}
  /* Created */
  async created() {
    if (this.$route.params.id) {
      this.loadItem(this.$route.params.id);
    }
  }
}
